import {
  TextInput as TextInputComponent,
  TextInputProps,
} from '@randstad-lean-mobile-factory/react-components-core';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../../ErrorMessage';

import { Props } from './NumberInputDeprecated.types';

/** @deprecated replace with `<TextInput type="number" />` which requires you to handle a number instead of a string */
export const NumberInputDeprecated = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  defaultValue,
  formFieldClassName,
  ...textInputProps
}: Props<TFieldValues, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
  });

  return (
    <div className={formFieldClassName}>
      <TextInputComponent
        {...textInputProps}
        {...field}
        onKeyDown={evt =>
          textInputProps.type === 'number' &&
          ['e', 'E', '+'].includes(evt.key) &&
          evt.preventDefault()
        }
        value={field.value as TextInputProps['value']}
      />
      <ErrorMessage error={error} />
    </div>
  );
};
